const namespace = '[Real Time]';

export const REAL_TIME_CONNECT = `${namespace} REAL TIME CONNECT`;
export const REAL_TIME_DISCONNECT = `${namespace} REAL TIME DISCONNECT`;
export const REAL_TIME_UPDATE_PLAYER = `${namespace} REAL TIME UPDATE PLAYER`;
export const NEW_REAL_TIME_UPDATE_PLAYER = `${namespace} NEW REAL TIME UPDATE PLAYER`;
export const REAL_TIME_INITIALIZE_DATA = `${namespace} REAL TIME INITIALIZE`;
